export { default as ChatOutlineIcon } from './ChatOutlineIcon';
